import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import { ManageTempMapMenu } from "../../../components";
import { withAppLayout } from "../../../hoc";
import {
  manageMapperFormNames,
  FLOW_TYPES,
  MANAGE_TEMPMAP_MENU,
} from "../../../utils";
import { ManagePayrollRoutes } from "../../../routes";
import {
  manageMapperStore,
  ManageMapperProvider,
  setManageMapperSelectedMenu,
} from "../../../contexts";

export const ManageTempMap = (props) => {
  const { location } = props;
  const { state, dispatch } = useContext(manageMapperStore);
  const isFixedLength = get(state, "api.data.format", 3) === 2;
  const isFetching = get(state, "api.isFetching", {});
  const profileId = get(state, "api.data.id");
  const flow = get(state, "flow");
  const data = get(state, "api.data", {});
  const formValues = get(state, "api.fileuploadData", "")
    ? get(state, "api.fileuploadData.mappingConfiguration", {})
    : get(state, "api.data", {});
  const editable = formValues.step;

  useEffect(() => {
    dispatch(setManageMapperSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const mapperName = get(
    state,
    `${manageMapperFormNames.MAP_AND_TRANSFORM}.mapperName`,
    ""
  );

  const isLoading = flow === FLOW_TYPES.ADD ? false : isFetching;
  const isEdit = flow === FLOW_TYPES.EDIT;

  return (
    <div className="row manage-company-wrapper">
      <Col className="h-100">
        <Row sm="12" className="h-100">
          <Col
            style={{ paddingTop: "20px" }}
            className="manage-company-column manage-menu-items"
          >
            <ManageTempMapMenu
              linkDisable={editable} //true
              menuList={MANAGE_TEMPMAP_MENU}
              selectedMenu={get(state, "selectedMenu")}
              flow={flow}
              profileId={profileId}
              isFixedLength={isFixedLength}
            />
          </Col>
          <Col className="h-100 manage-menu-content w-50">
            <ManagePayrollRoutes mapperName={mapperName} />
          </Col>
        </Row>
      </Col>
    </div>
  );
};

const ManageMapperWithProvider = (props) => {
  return (
    <ManageMapperProvider>
      <ManageTempMap {...props} />
    </ManageMapperProvider>
  );
};

export default withAppLayout(ManageMapperWithProvider);
